import axios from 'axios'
import router from '../router'
import { Notification, MessageBox } from 'element-ui'
import * as storage from './storage'
import * as constants from '@/constants'

/**
 * 提示函数，显示1s后关闭
 * @param {String} message 提示信息
 */
const tip = message => {
  Notification.error({
    title: 'Error',
    message,
    duration: 5000,
    showClose: false
  })
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  const info = storage.getItem(constants.WX_INFO)
  if (info) {
    router.replace({
      path: '/wxlogin.html'
    })
  } else {
    router.replace({
      path: '/login.html',
      query: {
        redirect: router.currentRoute.fullPath
      }
    })
  }
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 * @param {String} other 其他请求失败信息
 */
const errorHandle = (status, message, errNo, payload) => {
  switch (status) {
    case 401:
      toLogin()
      break
    case 403:
      tip('登录过期，请重新登录')
      setTimeout(() => {
        toLogin()
      }, 1000)
      break
    case 404:
      tip('请求的资源不存在')
      break
    case 500:
      tip('服务器开小差了，请稍后再试')
      break
    case 400:
      const { pathname } = window.location
      const info = storage.getItem(constants.WX_INFO) && pathname === '/jointeam.html'
      if (info) {
        tip('微信账号未绑定注册，请前往绑定注册!')
        router.replace({
          path: '/wxlogin.html'
        })
      } else if (errNo == 100) {
        MessageBox.alert(message, 'Error')
      } else {
        tip(message)

      }
      break
    case 300:
      if (payload.url) {
        window.location.href = payload.url
      }
    default:
      tip(message)
  }
}

// 创建axios实例
const instance = axios.create({
  timeout: 0,
  withCredentials: false
})

// 设置post请求头
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

/**
 * 请求拦截器
 */
instance.interceptors.request.use(
  config => {
    return config
  },
  error => Promise.reject(error)
)

/**
 * 响应拦截器
 */
instance.interceptors.response.use(

  res => {

    return new Promise((resolve, reject) => {
      res.status >= 200 && res.status < 300 ? resolve(res.data) : reject(res)
    })
  },
  error => {
    const { response } = error
    if (response) {
      if (window.navigator.onLine) {
        errorHandle(response.status, response.data.errMsg, response.data.errNo, response.data.payload)
      } else {
        tip('断网了')
      }
    } else {
      if (error.message.indexOf('timeout') !== -1) {
        tip('服务器繁忙,请稍后刷新页面再试')
      } else {
        // console.log(error)
        return Promise.reject(error)
      }
    }
  }
)

export default instance
